// Keep Dawn's drawer focus and scroll state in sync for same-page navigation.
document.addEventListener('click', (event) => {
  const link = event.target.closest('header-drawer a[href]');
  if (!link || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const destination = new URL(link.href, window.location.href);
  if (destination.origin !== location.origin || destination.pathname !== location.pathname || !destination.hash) return;
  const target = document.getElementById(decodeURIComponent(destination.hash.slice(1)));
  const drawer = link.closest('header-drawer');
  const toggle = drawer.querySelector(':scope > details > summary');
  if (!target || !toggle || typeof drawer.closeMenuDrawer !== 'function') return;
  drawer.closeMenuDrawer(event, toggle);
  toggle.setAttribute('aria-expanded', 'false');
  target.setAttribute('tabindex', '-1');
  target.focus({ preventScroll: true });
  target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
});
